import { render, staticRenderFns } from "./AssignSupervision.vue?vue&type=template&id=3f016def"
import script from "./AssignSupervision.vue?vue&type=script&lang=js"
export * from "./AssignSupervision.vue?vue&type=script&lang=js"
import style0 from "./AssignSupervision.vue?vue&type=style&index=0&id=3f016def&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports